import { Component, OnDestroy } from "@angular/core"
import { Unsubscribe } from "@angular/fire/firestore"
import { FormControl } from "@angular/forms"
import {
  MonoTypeOperatorFunction,
  Observable,
  startWith,
  Subject,
  takeUntil,
  tap
} from "rxjs"

@Component({
  template: "",
  standalone: false
})
export abstract class BaseCustomComponent implements OnDestroy {
  private ngDestroy$ = new Subject<void>()
  protected unsub?: Unsubscribe

  cleanSubscribe<T>(obs: Observable<T>, tapped: (value: T) => void) {
    return obs.pipe(takeUntil(this.ngDestroy$), tap(tapped)).subscribe()
  }

  unsubAll() {
    this.ngDestroy$.next()
  }

  ngOnDestroy() {
    this.unsubAll()
    if (this.unsub) {
      this.unsub()
    }

    this.ngDestroy$.complete()
  }

  until<T>(): MonoTypeOperatorFunction<T> {
    return takeUntil(this.ngDestroy$)
  }

  subscribeTo<T>(obs: Observable<T>, tapped: (value: T) => void) {
    return obs.pipe(this.until()).subscribe(tapped)
  }

  obsFor<T>(control: FormControl<T>) {
    return control.valueChanges.pipe(startWith(control.value), this.until())
  }

  stopProp(event: Event) {
    event.stopPropagation()
    return true
  }
}
